import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepParticipantsFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepCommunicatorsFormContainer.jsx';

const EditProfileStepParticipants = ({ projectId, stakeholderId, slug }) => (
  <>
    <Helmet>
      <title>Edit Stakeholder | ChangeSync</title>
    </Helmet>
    <StepParticipantsFormContainer
      projectId={projectId}
      stakeholderId={stakeholderId}
      slug={slug}
    />
  </>
);

EditProfileStepParticipants.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  stakeholderId: Number(query.stakeholderId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditProfileStepParticipants));
